import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NumerisationCentersService {
  private iCourrierURL: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }
  getGlobalCentreNumerisation(): Observable<GlobalCentreNumerisationDTO[]> {
    return this.http.get<GlobalCentreNumerisationDTO[]>(`${this.iCourrierURL}/Global/CentreNumerisations`);
  }
}
